import styled from '@mui/material/styles/styled'
import Typography from '@mui/material/Typography'

export const ViewDetailsText = styled(Typography, {
  name: 'ViewDetailsText',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
})({
  color: '#19305A',
  fontFamily: 'Source Sans Pro',
  fontSize: '14px',
  lineHeight: '48px',
})
